export default __webpack_public_path__ + "static/media/dot_streetlight-selected.53735cae.svg";